import { Platform } from "react-native";
import styles from "@stylesheet";
import React, { useState } from "react";
import { FlatList, Image, Pressable, View, ScrollView } from "react-native";
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { Image as ExpoImage } from 'expo-image';
import { AntDesign } from '@expo/vector-icons';
import { XStack, YStack } from 'tamagui';

// Platform-specific HorizontalCarousel import
let HorizontalCarousel: any;
if (Platform.OS === 'web') {
  // Use the simpler web-compatible version
  HorizontalCarousel = require("@components/Global/Carousel/HorizontalCarousel").default;
} else {
  // Use native version with gesture handlers
  HorizontalCarousel = require("@components/Global/Carousel/HorizontalCarousel.native").default;
}

const PhotoGallery = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!images || images.length === 0) {
    return null;
  }

  // Web-safe carousel implementation
  const WebCarousel = () => {
    const goToPrevious = () => {
      setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const goToNext = () => {
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
      <View style={{ flex: 1, width: '100%', position: 'relative', minHeight: 400 }}>
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#f3f4f6', borderRadius: 12, overflow: 'hidden' }}>
          <ExpoImage
            source={{ uri: typeof images[currentIndex] === 'string' ? images[currentIndex] : images[currentIndex]?.uri || images[currentIndex]?.url }}
            style={{ width: '100%', height: '100%' }}
            contentFit="contain"
          />
        </View>
        {images.length > 1 && (
          <>
            <Pressable
              onPress={goToPrevious}
              style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: [{ translateY: -20 }],
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: 20,
                width: 40,
                height: 40,
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10
              }}
            >
              <AntDesign name="arrowleft" size={20} color="white" />
            </Pressable>
            <Pressable
              onPress={goToNext}
              style={{
                position: 'absolute',
                right: 10,
                top: '50%',
                transform: [{ translateY: -20 }],
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: 20,
                width: 40,
                height: 40,
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10
              }}
            >
              <AntDesign name="arrowright" size={20} color="white" />
            </Pressable>
            <View style={{
              position: 'absolute',
              bottom: 10,
              left: 0,
              right: 0,
              flexDirection: 'row',
              justifyContent: 'center',
              gap: 8,
              zIndex: 10
            }}>
              {images.map((_, index) => (
                <View
                  key={index}
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: index === currentIndex ? 'rgb(90,192,234)' : 'rgba(255, 255, 255, 0.5)'
                  }}
                />
              ))}
            </View>
          </>
        )}
      </View>
    );
  };

  return (
    <View style={{ flex: 1, width: '100%' }}>
      <View style={{ flex: 1, minHeight: 400 }}>
        {Platform.OS === 'web' ? (
          <WebCarousel />
        ) : (
            <HorizontalCarousel
              images={images}
              removeSampleMark
              autoPlay={false}
              height={400}
              imageStyle={{ resizeMode: 'contain' }}
            />
        )}
      </View>
      {images.length > 1 && (
        <View style={{ marginTop: 20, paddingVertical: 10 }}>
          {Platform.OS === 'web' ? (
            <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{ gap: 15, paddingHorizontal: 10 }}>
              {images.map((item, index) => (
                <Pressable
                  key={index}
                  onPress={() => setCurrentIndex(index)}
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: 8,
                    overflow: 'hidden',
                    borderWidth: 2,
                    borderColor: index === currentIndex ? 'rgb(90,192,234)' : '#e5e7eb'
                  }}
                >
                  <ExpoImage
                    source={{ uri: typeof item === 'string' ? item : item.uri || item.url }}
                    style={{ width: '100%', height: '100%' }}
                    contentFit="cover"
                  />
                </Pressable>
              ))}
            </ScrollView>
          ) : (
              <FlatList
                data={images}
                horizontal
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={{ gap: 15, paddingHorizontal: 10 }}
                renderItem={({ item, index }) => (
                  <Image
                    source={{ uri: typeof item === 'string' ? item : item.uri || item.url }}
                    style={{
                      width: 80,
                      height: 80,
                      borderRadius: 8,
                      borderWidth: 2,
                      borderColor: '#e5e7eb'
                    }}
                  />
                )}
                keyExtractor={(item, index) => typeof item === 'string' ? item : item.uri || item.url || index.toString()}
              />
          )}
        </View>
      )}
    </View>
  )
}
export default PhotoGallery;